import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import {ThemeProvider} from "@material-ui/core";
import {IInsideOrbitMenuServices} from "../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {generateMenuItems} from "./inside-orbit-menu-action/generate-menu-actions/generate-menu-items-actions";
import {buttonStyle} from "./inside-orbit-menu-styles/inside-menu-orbit-button.style";
import {menuItemsTheme} from "./inside-orbit-menu-styles/inside-menu-orbit-menu-item.style";

export default function InsideOrbitMenuComponent(props: {services: IInsideOrbitMenuServices, isMobileNotTablet: boolean}) {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    // In order to toggle the menu off after clicking on an item
    const wrapHandlerWithToggle = (handler: () => void) => {
        handler();
        handleToggle();
    };

    const menuItems = generateMenuItems(props.services);
    return (
        <div>
            <Button
                // On mobile, the menu is placed within the side-menu and needs different styling
                style={{...buttonStyle, width : props.isMobileNotTablet ? "90%" : "100%", marginTop: props.isMobileNotTablet ? "5px" : "auto" }}
                color = "primary"
                variant = "outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
            >
                QA
            </Button>
            <Popper style = {{ zIndex: 1000 }} open={open} anchorEl={anchorRef.current} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <ThemeProvider theme={menuItemsTheme} >
                                    <MenuList autoFocusItem={open} id="menu-list-grow">
                                        {menuItems.map((mi, index) => <MenuItem key = {index}  onClick={() => wrapHandlerWithToggle(mi.execute)}>{mi.text}</MenuItem>)}
                                    </MenuList>
                                </ThemeProvider>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
}